import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { setCookie } from '../utils/cookie';
import I18n, { coubicLocale } from '../utils/i18n';
import { setCoubicLocaleRequestHeader } from '../utils/secured-axios';

export interface LocaleContextProps {
  locale: string;
}

export interface LocaleContextState {
  currentLocale: coubicLocale;
  changeLocale: (l: string) => void;
}

export const LocaleContext = React.createContext<LocaleContextState>({
  currentLocale: I18n.defaultLocale,
  changeLocale: () => undefined,
});

export class LocaleContextProvider extends React.Component<
  LocaleContextProps,
  LocaleContextState
> {
  public state: LocaleContextState;

  constructor(props: LocaleContextProps) {
    super(props);

    this.changeLocale = this.changeLocale.bind(this);
    this.state = {
      currentLocale: I18n.validLocale(props.locale),
      changeLocale: this.changeLocale,
    };

    if (I18n.isAvailableCoubicLocale(props.locale)) {
      setCoubicLocaleRequestHeader(props.locale);
    }
  }

  private changeLocale(l: string) {
    setCookie('hl', l);

    if (I18n.isAvailableCoubicLocale(l)) {
      setCoubicLocaleRequestHeader(l);
    }

    // setStateで効かない部分があるように見える
    // this.setState({
    //   ...this.state,
    //   currentLocale: I18n.validLocale(l),
    // });

    location.reload(false);
  }

  public render() {
    return (
      <LocaleContext.Provider value={this.state}>
        <IntlProvider
          locale={this.state.currentLocale}
          messages={I18n.messages(this.state.currentLocale)}
        >
          {this.props.children}
        </IntlProvider>
      </LocaleContext.Provider>
    );
  }
}

// then make a consumer which will surface it
export const LocaleContextConsumer = LocaleContext.Consumer;
